// Release switch for lean-back mode (OMG-2747). Read at render time, like
// simulationsEnabled, so a stage's Secrets Manager env decides without a
// code change: `VITE_LEANBACK_ENABLED=true` turns it on, `false` turns it
// off. Unset means on for the QA stages (UAT, foxhole, local) and off in
// production, so a merge to `development` soaks on UAT before anyone flips
// prod. Off: no entry button, the watch route goes back to the page, and the
// provider mounts no parked player, so the page loads nothing for it.
export function leanBackEnabled(
  env: { VITE_LEANBACK_ENABLED?: string; VITE_ENV?: string } = import.meta.env,
): boolean {
  const value = (env.VITE_LEANBACK_ENABLED ?? "").trim().toLowerCase();
  if (value === "true") return true;
  if (value === "false") return false;
  return /^(uat|foxhole|local)$/i.test(env.VITE_ENV ?? "");
}
